import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import './mixins/mixins'
import ReuseableComponents from "@/components/ReuseableComponents/reuseableComponents.js";

import i18n from '../i18n'
ReuseableComponents.forEach((component) => {
  Vue.component(component.name, component);
});


/* add fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)
/* add some free styles */
import { faUserSecret, faExclamation,  faRefresh,faSearch ,faClose, faComment,faCommentAlt, faUser ,faMapMarkerAlt, faPhoneAlt, faLock , faLanguage , faBell , faBars , faEnvelope, faPhone, faCertificate, faQuestion, faLocation , faSignOut ,faDollar,faEye, faPlus,faMinus} from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
library.add(faUserSecret,faExclamation,faRefresh,faSearch,faClose,faComment,faCommentAlt, faUser,faMapMarkerAlt,faPhoneAlt,faLock, faLanguage, faBell,faEye, faBars,faEnvelope, faSignOut ,faDollar,  faPhone,faCertificate, faQuestion, faLocation, faWhatsapp, faPlus,faMinus)


import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);


import VeeValidate from "vee-validate";
Vue.use(VeeValidate, { inject: true,fieldsBagName: 'veeFields' });
import { ValidationObserver, ValidationProvider } from "vee-validate";
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);


let options = {
  autoFormat: false,
  validCharactersOnly: true,
  mode: 'international',
  defaultCountry: 'AE',
  dropdownOptions: {
    showFlags: true,
    showSearchBox: true,
    showDialCodeInSelection: true,
  },
  inputOptions: {
    showDialCode: false,
    
    placeholder: "",
    name:"number"
  },
}
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

Vue.use(VueTelInput ,options);

import VueCountryCode from "vue-country-code";

Vue.use(VueCountryCode);


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
